(function () {
    window.initShipping = function () {
        $.ajax({
            url: "https://apps.homestoreservice.com/base/get_shipping_zone?site_id=5001&address=https://gifts-journey.myshopify.com/admin/shipping_zones.json",
            type: 'GET',
            dataType: 'jsonp',
            success: function (result) {
                window.myshop = {
                    shipping_zones: result.shipping_zones,
                }
                
                window.setShippingPrice();
            }
        });
    };
    window.setShippingPrice = function () {
      if(!window.myshop){
      	return;
      }
      	var money_format = $('#current_format').val();
      	var s_price = $('#current_price').val();
        var s_weight = $('#current_weight').val();
      
      	var qty = parseInt(jQuery('#quantity').val());
      	var sweight=s_weight*qty;
      	var price=s_price*qty;
      
        var weight = sweight / 1000;
        if (window.myshop.shipping_zones.length < 1) {
            return;
        }
        var group = [];
        var szone = window.myshop.shipping_zones[0];
        var country = $.map(szone.countries, function (ele) {
            return ele.name;
        }).join(', ');
        var sitem = {
            name: country,
          	list:[],
            price_list: [],
          	weight_list:[],
        };
        var price_rate = szone.price_based_shipping_rates;
        for (var i = 0; i < price_rate.length; i++) {
            if (price >= price_rate[i].min_order_subtotal * 100 && (price <= price_rate[i].max_order_subtotal *
                    100 || price_rate[i].max_order_subtotal == null)) {
                sitem.price_list.push({
                    name: price_rate[i].name,
                    price: price_rate[i].price,
                });
            }
        }
        var weight_rate = szone.weight_based_shipping_rates;
        
        for (var j = 0; j < weight_rate.length; j++) {
            if (weight >= weight_rate[j].weight_low && weight <= weight_rate[j].weight_high) {
                sitem.weight_list.push({
                    name: weight_rate[j].name,
                    price: weight_rate[j].price,
                });
            }
        }
        //var usedItems = [];

//         sitem.list.forEach(function (ele) {
//             if (ele.price == 0) {
//               	ele.name=ele.name.split('(')[0];
//                 freeItems.push(ele);
//                 return;
//             }
//         });
        //sitem.list = sitem.price_list.length == 0 ? sitem.weight_list : sitem.price_list;
      var shipping_list=sitem.price_list.concat(sitem.weight_list);
      sitem.list=[];
      for(var i=0;i<shipping_list.length;i++){
        var hasItme=false;
        for(var j=0;i<sitem.list.length;j++){
          if(sitem.list[j].name==shipping_list[i].name){
            sitem.list[j].price=sitem.list[j].price<shipping_list[i].price?sitem.list[j].price:shipping_list[i].price;
            hasItme=true;
            break;
          }
        }
        if(!hasItme){
        	sitem.list.push({
               name: shipping_list[i].name,
               price: shipping_list[i].price,
            });
        }
      }
        group.push(sitem);
        // if (window.myshop.shipping_zones.length < 2) {
        //     return;
        // }
        // var izone = window.myshop.shipping_zones[1];
        // var world = izone.name;
        // var witem = {
        //     name: world,
        //     list: [],
        // };
        // var world_weight_rate = izone.weight_based_shipping_rates;
        // for (var j = 0; j < world_weight_rate.length; j++) {
        //     if (weight >= world_weight_rate[j].weight_low && weight <= world_weight_rate[j].weight_high) {
        //         witem.list.push({
        //             name: world_weight_rate[j].name,
        //             price: world_weight_rate[j].price,
        //         });
        //     }
        // }
        // group.push(witem);
        var shtml = ['<ul class="shipping-group">'];
        group.forEach(function (element) {
            //shtml.push('<li><div class="shipping_group">' + element.name + '</div>');
          	shtml.push('<li>');
            shtml.push('<ul class="shipping-list">');
            element.list.forEach(function (ele) {
              var price_value=ele.price == 0?"Free":Shopify.formatMoney(ele.price, money_format);
                var price_ele = ' at </span><span class="money shipping_price">' + price_value + '</span>';
                shtml.push('<li><span class="shipping_name">' + ele.name + price_ele + '</li>');
            });
            shtml.push('</ul>');
            shtml.push('</li>');
        });
        shtml.push('</ul>');
        $('#shipping_section').empty();
        $('#shipping_section').append(shtml.join(''));
        //return $('#shipping_section').find('.money');
    }
    
    window.initShipping();
})();